module.exports = (__parcel__import__("k4NwQ")).then(() => parcelRequire('fyWP3'));